import React, { useState, useEffect, useContext } from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import { UserContext } from '../../UserContext';
import { useHttpClient } from '../hooks/useHttpClient';
import { useNotificacoes } from '../hooks/useNotificacoes';

import styles from './DetalharProducaoUsina.module.css';
import styles_global from '../css/global.module.css';
import styles_content from '../css/main-content.module.css';

function DetalharProducaoUsina() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const { get } = useHttpClient();
    const { exibirErro } = useNotificacoes();

    const [usinas, setUsinas] = useState([]);
    const [formData, setFormData] = useState({
        idUsina: '',
        mesProducao: '',
        qtdProducao: '',
        dtInicioProducao: '',
        dtFimProducao: '',
    });

    // formata data ISO → dd/mm/yyyy
    const formatDate = iso => {
        const d = new Date(iso);
        if (isNaN(d)) return '';
        return [
            d.getDate().toString().padStart(2, '0'),
            (d.getMonth()+1).toString().padStart(2, '0'),
            d.getFullYear(),
        ].join('/');
    };

    // formata número → string com vírgula
    const formatKwh = value => {
        const num = parseFloat(value);
        if (isNaN(num)) return '';
        return num.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    };

    useEffect(() => {
        if (!user || !id) return;

        (async () => {
            try {
                // 1) Carrega detalhes da produção
                const prod = await get(`/hello-sol/producao-usinas/${id}`);
                setFormData({
                    idUsina: prod.usina.id,
                    mesProducao: prod.mesProducao,
                    qtdProducao: formatKwh(prod.qtdProducao),
                    dtInicioProducao: formatDate(prod.dtInicioProducao),
                    dtFimProducao: formatDate(prod.dtFimProducao),
                });

                // 2) Então carrega as usinas da mesma empresa gestora
                const empresaId = prod.usina.empresaGestora?.id;
                if (empresaId) {
                    const lista = await get(`/hello-sol/usinas/buscar?idEmpresa=${empresaId}`);
                    setUsinas(Array.isArray(lista) ? lista : (lista.content || []));
                }
            } catch (err) {
                exibirErro(err.message || 'Erro ao carregar detalhes da produção.');
            }
        })();
    }, [user, id]);

    return (
        <div className={styles_global.container}>
            <h2>Detalhar Produção de Usina</h2>

            <form>
                {/* Linha 1 */}
                <div className={styles.linha2}>
                    <div className={styles_content.formField}>
                        <label htmlFor="idUsina">Usina</label>
                        <select name="idUsina" id="idUsina"
                                value={formData.idUsina} disabled>
                            <option value="">Selecionar Usina</option>
                            {usinas.map(u =>
                                <option key={u.id} value={u.id}>{u.nome}</option>
                            )}
                        </select>
                    </div>

                    <div className={styles_content.formField}>
                        <label htmlFor="mesProducao">Mês de Produção</label>
                        <select name="mesProducao" id="mesProducao"
                                value={formData.mesProducao} disabled>
                            <option value="">Selecionar Mês</option>
                            {[...Array(12)].map((_, i) =>
                                <option key={i+1} value={i+1}>
                                    {new Date(0, i).toLocaleString('pt-BR', { month: 'long' }).replace(/^\w/, c => c.toUpperCase())}
                                </option>
                            )}
                        </select>
                    </div>
                </div>

                {/* Linha 2 */}
                <div className={styles.linha3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="qtdProducao">Quantidade KWh Produzido</label>
                        <input type="text" id="qtdProducao" name="qtdProducao"
                               value={formData.qtdProducao} disabled />
                    </div>

                    <div className={styles_content.formField}>
                        <label htmlFor="dtInicioProducao">Data Início</label>
                        <input type="text" id="dtInicioProducao" name="dtInicioProducao"
                               value={formData.dtInicioProducao}
                               placeholder="dd/mm/aaaa" disabled />
                    </div>

                    <div className={styles_content.formField}>
                        <label htmlFor="dtFimProducao">Data Fim</label>
                        <input type="text" id="dtFimProducao" name="dtFimProducao"
                               value={formData.dtFimProducao}
                               placeholder="dd/mm/aaaa" disabled />
                    </div>
                </div>

                {/* Botão de voltar */}
                <div className={styles_content.buttonGroup}>
                    <button
                        type="button"
                        onClick={() => navigate('/home/listar-producao-usina')}
                    >
                        Voltar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default DetalharProducaoUsina;
